import React, { useEffect, useRef, useState } from "react";
import "./cardapios.css";

import Footer from "../../components/footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
  faStar as faStarSolid,
  faUtensils,
  faMugHot,
  faAppleWhole,
  faDrumstickBite,
  faClipboard
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";

const API_BASE = process.env.REACT_APP_API_BASE || "";

const TIPOS_REFEICAO = [
  { id: "cafe", label: "Café da manhã", icon: faMugHot },
  { id: "almoco", label: "Almoço", icon: faUtensils },
  { id: "lanche", label: "Lanche", icon: faAppleWhole },
  { id: "jantar", label: "Jantar", icon: faDrumstickBite }
];

const BADGES_DISPONIVEIS = [
  { id: "vegano", label: "Vegano" },
  { id: "low_carb", label: "Low carb" },
  { id: "sem_lactose", label: "Sem lactose" },
  { id: "sem_gluten", label: "Sem glúten" },
  { id: "baixo_acucar", label: "Baixo açúcar" },
  { id: "leve", label: "Leve" }
];

const Cardapios = () => {
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [cardapios, setCardapios] = useState({});
  const [favoritos, setFavoritos] = useState([]);

  // 🔹 filtros de tipo de refeição (sempre >= 1 ativo)
  const [filtrosAtivos, setFiltrosAtivos] = useState(
    TIPOS_REFEICAO.map(t => t.id)
  );

  // 🔹 filtros de preferência alimentar
  const [filtrosPreferencia, setFiltrosPreferencia] = useState([]);

  // 🔹 busca textual
  const [busca, setBusca] = useState("");

  // 🔹 toast
  const [toast, setToast] = useState("");

  const carrosseisRef = useRef({});

  // Verificar plano
  const [statusPlano, setStatusPlano] = useState(null);


  // ==========================================================
  // 🔹 LER ?ref=lanche | cafe | almoco | jantar
  // ==========================================================
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");

    if (ref && TIPOS_REFEICAO.some(t => t.id === ref)) {
      setFiltrosAtivos([ref]);
    }
  }, []);


const carregarStatusPlano = async () => {
  try {
    const res = await fetch(`${API_BASE}/painel-dados.php`, {
      credentials: "include"
    });
    const json = await res.json();
    return json.status_plano || null;
  } catch {
    return null;
  }
};




  // ==========================================================
  // CARREGAR DADOS
  // ==========================================================
  const carregarDados = async () => {
    try {
      
      const resCardapios = await fetch(`${API_BASE}/getcardapios.php`, {
        credentials: "include"
      });
      const dataCardapios = await resCardapios.json();

      const resFav = await fetch(`${API_BASE}/get-favoritos-cardapios.php`, {
        credentials: "include"
      });
      const dataFav = await resFav.json();

      setCardapios(dataCardapios.cardapios || {});
      setFavoritos(dataFav.favoritos || []);
      setLoading(false);
    } catch {
      setErro("Erro ao carregar os dados.");
      setLoading(false);
    }
  };

 useEffect(() => {
  (async () => {
    const status = await carregarStatusPlano();
    setStatusPlano(status);
    carregarDados(); // continua igual por enquanto
  })();
}, []);


  // ==========================================================
  // RESETAR CARROSSEIS
  // ==========================================================
  useEffect(() => {
    if (!loading && cardapios) {
      Object.values(carrosseisRef.current).forEach(el => {
        if (el) el.scrollLeft = 0;
      });
    }
  }, [loading, cardapios, filtrosAtivos, filtrosPreferencia, busca]);

  // ==========================================================
  // FILTROS
  // ==========================================================
  const toggleFiltro = (tipo) => {
    setFiltrosAtivos(prev => {
      if (prev.includes(tipo)) {
        // ❗ impede ficar sem nenhum tipo ativo
        if (prev.length === 1) return prev;
        return prev.filter(t => t !== tipo);
      }
      return [...prev, tipo];
    });
  };

  const togglePreferencia = (pref) => {
    setFiltrosPreferencia(prev =>
      prev.includes(pref)
        ? prev.filter(p => p !== pref)
        : [...prev, pref]
    );
  };

  // ==========================================================
  // FAVORITOS
  // ==========================================================
  const isFavorito = (id) => favoritos.includes(id);

  const toggleFavorito = async (id) => {
    setFavoritos(prev =>
      prev.includes(id)
        ? prev.filter(f => f !== id)
        : [...prev, id]
    );

    try {
      await fetch(`${API_BASE}/toggle-favorito-cardapio.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cardapio_id: id })
      });
    } catch {}
  };

  // ==========================================================
  // COPIAR ITENS
  // ==========================================================
  const copiarItens = (texto) => {
    navigator.clipboard.writeText(texto);
    setToast("Texto da refeição copiado com sucesso");
    setTimeout(() => setToast(""), 2000);
  };

  // ==========================================================
  // FILTRO FINAL (AND GLOBAL)
  // ==========================================================
  const aplicarFiltros = (item) => {
    const passaPreferencia = filtrosPreferencia.every(
      pref => item.badges?.[pref] === true
    );

    const termo = busca.toLowerCase();
    const passaBusca =
      !termo ||
      item.titulo.toLowerCase().includes(termo) ||
      (item.descricao || "").toLowerCase().includes(termo) ||
      item.itens.toLowerCase().includes(termo);

    return passaPreferencia && passaBusca;
  };

  // ==========================================================
  // LISTA GLOBAL FILTRADA (BASE PARA CONTADOR E EMPTY STATE)
  // ==========================================================
  const listaFiltradaGlobal = TIPOS_REFEICAO
    .filter(t => filtrosAtivos.includes(t.id))
    .flatMap(t => cardapios[t.id] || [])
    .filter(aplicarFiltros);

  const totalGeral = Object.values(cardapios).flat().length;
  const totalFiltrado = listaFiltradaGlobal.length;

  const nenhumResultado = !loading && totalFiltrado === 0;

  // ==========================================================
  // CARROSSEL
  // ==========================================================
  const scrollCarrossel = (tipo, direcao) => {
    const el = carrosseisRef.current[tipo];
    if (!el) return;

    const scroll = direcao === "left" ? -320 : 320;
    el.scrollBy({ left: scroll, behavior: "smooth" });
  };


// ==========================================================
// 🔒 BLOQUEIO — TESTE GRATUITO ENCERRADO
// ==========================================================
if (statusPlano === "teste_acabou") {
  return (
    <div className="cardapios-container">

      <div className="cardapios-topo-central">
        <img
          src="/assets/logo2.png"
          alt="Logo"
          className="cardapios-logo-central"
        />
      </div>

      <div className="cardapios-aviso-bloqueio">
        <h2>Sugestões disponíveis no acesso completo</h2>

        <p>
          Seu teste terminou. Para continuar vendo sugestões de refeições
          e cardápios, libere o acesso completo.
        </p>

        <a href="/acesso" className="cardapios-cta-botao">
          Ver planos
        </a>

        <p className="cardapios-link-texto">
          <a href="/acesso">Libere o acesso completo</a>
        </p>
      </div>

      <Footer />
    </div>
  );
}


// ==========================================================
// 🔒 BLOQUEIO — PLANO EXPIRADO
// ==========================================================
if (statusPlano === "expirado") {
  return (
    <div className="cardapios-container">

      <div className="cardapios-topo-central">
        <img
          src="/assets/logo2.png"
          alt="Logo"
          className="cardapios-logo-central"
        />
      </div>

      <div className="cardapios-aviso-bloqueio">
        <h2>Acesso ativo necessário</h2>

        <p>
          Seu período de acesso terminou. Para voltar a visualizar
          sugestões de refeições e cardápios, é necessário um acesso ativo.
        </p>

        <a href="/acesso" className="cardapios-cta-botao">
          Ver opções de acesso
        </a>

        <p className="cardapios-link-texto">
          <a href="/acesso">Ativar acesso novamente</a>
        </p>
      </div>

      <Footer />
    </div>
  );
}



  // ==========================================================
  // RENDER
  // ==========================================================
  return (
    <div className="cardapios-container">

    {/* TOPO PADRÃO (igual Painel) */}
<div className="cardapios-topo-central">
  <img
    src="/assets/logo2.png"
    alt="Logo"
    className="cardapios-logo-central"
  />
</div>


      {/* HEADER */}
      <div className="cardapios-header">
        <h1 className="cardapios-titulo">
          <span className="cardapios-icone-ideia">💡</span>
          Ideias de Refeições
        </h1>

        <p className="cardapios-subtitulo">
          Explore opções por refeição. Use como referência e adapte à sua rotina.
        </p>
      </div>

      {/* FILTRO POR REFEIÇÃO */}
      <h3>Filtrar por tipo de refeição</h3>
      <div className="cardapios-filtros">
        {TIPOS_REFEICAO.map(tipo => (
          <button
            key={tipo.id}
            className={
              filtrosAtivos.includes(tipo.id)
                ? "filtro-chip ativo"
                : "filtro-chip"
            }
            onClick={() => toggleFiltro(tipo.id)}
          >
            <FontAwesomeIcon icon={tipo.icon} />
            <span>{tipo.label}</span>
          </button>
        ))}
      </div>

      {/* FILTRO POR PREFERÊNCIA */}
      <h3>Filtrar por preferência alimentar</h3>
      <div className="cardapios-filtros">
        {BADGES_DISPONIVEIS.map(b => (
          <button
            key={b.id}
            className={
              filtrosPreferencia.includes(b.id)
                ? "filtro-chip ativo"
                : "filtro-chip"
            }
            onClick={() => togglePreferencia(b.id)}
          >
            {b.label}
          </button>
        ))}
      </div>

      {/* BUSCA */}
      <input
        type="text"
        className="cardapios-busca"
        placeholder="Buscar por ingrediente ou nome"
        value={busca}
        onChange={e => setBusca(e.target.value)}
      />

      {/* CONTADOR */}
      <p className="cardapios-contador">
        Mostrando {totalFiltrado} de {totalGeral} refeições
      </p>

      {/* EMPTY STATE (BASE PARA CSS FUTURO) */}
      {nenhumResultado && (
        <div className="cardapios-vazio">
          <p>Nenhuma refeição encontrada com os filtros selecionados.</p>
        </div>
      )}

      {/* CONTEÚDO */}
      {!loading && !erro && !nenhumResultado && (
        <div className="cardapios-conteudo">
          {TIPOS_REFEICAO.filter(t => filtrosAtivos.includes(t.id)).map(tipo => {
            const lista = (cardapios[tipo.id] || []).filter(aplicarFiltros);
            if (!lista.length) return null;

            return (
              <section key={tipo.id} className="cardapios-carrossel-bloco">
                <div className="cardapios-carrossel-header">
                  <div className="carrossel-titulo">
                    <FontAwesomeIcon icon={tipo.icon} />
                    <h2>{tipo.label}</h2>
                  </div>

                  <div className="carrossel-setas">
                    <button onClick={() => scrollCarrossel(tipo.id, "left")}>
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <button onClick={() => scrollCarrossel(tipo.id, "right")}>
                      <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                  </div>
                </div>

                <div
                  className="cardapios-carrossel"
                  ref={el => (carrosseisRef.current[tipo.id] = el)}
                >
                  {lista.map(item => (
                    <div key={item.id} className="cardapio-card">
                      <div className="cardapio-card-topo">
                        <h3>{item.titulo}</h3>
                        <button
                          className="cardapio-favorito"
                          onClick={() => toggleFavorito(item.id)}
                        >
                          <FontAwesomeIcon
                            icon={isFavorito(item.id) ? faStarSolid : faStarRegular}
                          />
                        </button>
                      </div>

                      <span className="cardapio-calorias">
                        {item.calorias} kcal
                      </span>

                      {item.descricao && (
                        <p className="cardapio-descricao">{item.descricao}</p>
                      )}

                      <div
                        className="cardapio-itens"
                        onClick={() => copiarItens(item.itens)}
                      >
                        {item.itens}
                        <FontAwesomeIcon
                          icon={faClipboard}
                          className="icone-copiar"
                        />
                      </div>

                      <div className="cardapio-badges">
                        {Object.entries(item.badges || {}).map(
                          ([key, val]) =>
                            val && (
                              <span key={key} className={`badge badge-${key}`}>
                                {key.replace("_", " ")}
                              </span>
                            )
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      )}

      {toast && <div className="toast-copiar">{toast}</div>}

      <Footer />
    </div>
  );
};

export default Cardapios;
